export default __webpack_public_path__ + "static/media/bgEnteringDetails_desktop.4d685979.svg";